import { BASIC_PLAN, SUBSCRIBER_PLAN } from "../../client/dashboard/pricingPlans";

export const PAYMENT_METHODS = {
  CARD: "card",
  PAYPAL: "paypal",
  SEPA: "sepa",
};

export function getPaymentMethodMeta(t) {
  return [
    {
      id: PAYMENT_METHODS.CARD,
      label: t("payment.methodCard"),
      description: t("payment.methodCardDesc"),
      icon: "credit_card",
    },
    {
      id: PAYMENT_METHODS.PAYPAL,
      label: t("payment.methodPaypal"),
      description: t("payment.methodPaypalDesc"),
      icon: "payments",
    },
    {
      id: PAYMENT_METHODS.SEPA,
      label: t("payment.methodSepa"),
      description: t("payment.methodSepaDesc"),
      icon: "account_balance",
    },
  ];
}

export function getDefaultCheckout(t, plan = "premium") {
  if (plan === "basic") {
    return {
      checkoutType: "subscription",
      plan: "basic",
      title: t("payment.basicTitle"),
      subtitle: t("payment.basicSubtitle"),
      lineItems: [
        {
          label: t("payment.basicPlanLine"),
          amount: BASIC_PLAN.monthlyPrice,
        },
      ],
      total: BASIC_PLAN.monthlyPrice,
      recurring: true,
    };
  }
  return {
    checkoutType: "subscription",
    plan: "premium",
    title: t("payment.subscriberTitle"),
    subtitle: t("payment.subscriberSubtitle"),
    lineItems: [
      {
        label: t("payment.subscriberPlanLine"),
        amount: SUBSCRIBER_PLAN.monthlyPrice,
      },
      {
        label: t("payment.includedDeletionsLine"),
        detail: t("payment.deletionsAllowance", {
          count: SUBSCRIBER_PLAN.freeDeletionsPerMonth,
        }),
        amount: 0,
      },
    ],
    total: SUBSCRIBER_PLAN.monthlyPrice,
    recurring: true,
  };
}

export function resolveCheckoutFromState(state, t) {
  if (!state || typeof state !== "object") {
    return getDefaultCheckout(t);
  }

  // Review deletion and other manual services are invoiced outside the platform.
  if (state.checkoutType === "deletion") {
    return getDefaultCheckout(t);
  }

  if (state.checkoutType === "subscription" || state.total != null) {
    const defaults = getDefaultCheckout(t, state.plan === "basic" ? "basic" : "premium");
    return {
      ...defaults,
      title: state.title || defaults.title,
      subtitle: state.subtitle || defaults.subtitle,
      lineItems: state.lineItems || defaults.lineItems,
      total: typeof state.total === "number" ? state.total : defaults.total,
      recurring: state.recurring ?? true,
    };
  }

  return getDefaultCheckout(t);
}

/** @deprecated Deletion charges are invoiced manually — use getDefaultCheckout for subscription only. */
export function buildDeletionCheckout(t, { reviewCount, caseTotal, tierLabel, lineItems }) {
  const items =
    lineItems ||
    (caseTotal > 0
      ? [
          {
            label: tierLabel
              ? t("payment.deletionLine", { tier: tierLabel })
              : t("payment.deletionLineGeneric"),
            amount: caseTotal,
          },
        ]
      : []);

  return {
    checkoutType: "deletion",
    title: t("payment.deletionPaymentTitle"),
    subtitle: t("payment.deletionSubtitle", { count: reviewCount }),
    lineItems: items,
    total: caseTotal,
    reviewCount,
    recurring: false,
  };
}
